var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import transform from 'lodash/transform';
import isArray from 'lodash/isArray';
import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import isObject from 'lodash/isObject';
import { formatNumber, parseNumber } from 'libphonenumber-js';
export const toCamelCase = (obj) => {
    const result = transform(obj, (acc, value, key, target) => {
        const camelKey = isArray(target) ? key : camelCase(key);
        acc[camelKey] = isObject(value) ? toCamelCase(value) : value;
    });
    return result;
};
export const toSnakeCase = (obj) => {
    const result = transform(obj, (acc, value, key, target) => {
        const snakeKey = isArray(target) ? key : snakeCase(key);
        acc[snakeKey] = isObject(value) ? toSnakeCase(value) : value;
    });
    return result;
};
export const convertZerosToPlus = (value) => {
    if (value.substring(0, 2) === '00') {
        return value.replace(/^.{2}/g, '+');
    }
    return value;
};
export const formatPhoneNumber = (value, locale) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const parsedNumber = parseNumber(convertZerosToPlus(value), locale);
        return formatNumber(parsedNumber, 'E.164').replace(/\s/g, '');
    }
    catch (e) {
        return '';
    }
});
export const sanitizeHtml = (value) => {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.body.textContent || '';
};
export const dateFormatter = (date, formatDate) => date
    ? formatDate(date, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    })
    : date;
/*
 *   The given size in bytes will be converted (binary calculation)
 *   and formatted to the most appropriate measurement unit.
 */
export const formatFileSize = (size) => {
    const units = ['B', 'kB', 'MB', 'GB', 'TB'];
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return `${(size / Math.pow(1024, i)).toFixed(2)} ${units[i]}`;
};
//# sourceMappingURL=formatters.js.map